import getCdiData from './getCdiData'
export const getCdiDataService = getCdiData;